import { Button } from '@workspace/ui/components/Button';
import { Typography } from '@workspace/ui/components/Typography';
import { useTranslation } from 'react-i18next';
import { company } from '~/company/Company';
import mapPinImg from '../assets/map-pin.png';

interface PudoMarkerProps {
  lat: number;
  lng: number;
  name: string;
  description?: string | null;
  color: string;
  isOpen: boolean;
  isLoading?: boolean;
  onToggle: () => void;
  onSelect: () => void;
}

export const PudoMarker = ({
  name,
  description,
  color,
  isOpen,
  isLoading,
  onToggle,
  onSelect,
}: PudoMarkerProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="relative size-8 -translate-x-1/2 -translate-y-full cursor-pointer"
      onClick={onToggle}
    >
      {company.match({
        mcosmetic: (
          <img src={mapPinImg} alt="map-pin" className="h-9 object-contain" />
        ),
        default: (
          <svg
            viewBox="0 0 24 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 0C5.372 0 0 5.372 0 12c0 9 12 24 12 24s12-15 12-24c0-6.628-5.372-12-12-12z"
              fill={color}
            />
            <circle cx="12" cy="12" r="5" fill="#fff" />
          </svg>
        ),
      })}

      {isOpen && (
        <div className="absolute bottom-[calc(100%+8px)] left-1/2 z-10 flex min-w-[180px] -translate-x-1/2 flex-col gap-2 rounded-4 bg-bg-base p-3 shadow-lg">
          <Typography.Text200Medium>{name}</Typography.Text200Medium>
          {description && (
            <Typography.Text200Regular>{description}</Typography.Text200Regular>
          )}
          <Button
            variant="brand"
            size="sm"
            isLoading={isLoading}
            className="mt-1 w-full cursor-pointer rounded-[6px]!"
            onClick={(e) => {
              e.stopPropagation();
              onSelect();
            }}
          >
            {t('select')}
          </Button>
        </div>
      )}
    </div>
  );
};
